var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%", "text-indent": "20px" } }, [
    _c("span", [_vm._v(_vm._s(_vm.params.displayName))]),
    _c("i", {
      staticClass: "el-icon-question",
      attrs: { title: _vm.params.title }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }